import { UserModel } from "../models/user.model";
import { MenuItemModel } from '@models/menu-item.model';

export const emptyUser = (): UserModel => {
    return {
        fullName: 'Carolina Ortega',
        email: '',
        firstName: '',
        lastName: '',
        uid: '',
        photoURL: '',
    };
};
export const navBarOptions = (): MenuItemModel[] => {
    return [
        {
            route: ['auth', 'login'],
            icon: 'person'
        },
        {
            route: ['auth', 'sign-up'],
            icon: 'group_add'
        },
        {
            route: ['home', 'news'],
            icon: 'autorenew'
        }]
}

export var menuItemsData = ():MenuItemModel[]=>{return []};

var area:string = localStorage.getItem("access");
if (area != null) {
    if (area === 'Configuración') {
        menuItemsData = (): MenuItemModel[] => {
            return [
                {
                    name: 'Inicio',
                    icon: 'home',
                    route: ['home', '']
                },
                {
                    name: 'Configuración',
                    icon: 'settings',
                    children: [
                        {
                            name: 'Clientes',
                            icon: 'settings',
                            route: ['configuration', 'customers']
                        },
                        {
                            name: 'Áreas',
                            icon: 'settings',
                            route: ['configuration', 'areas']
                        },
                        {
                            name: 'Lista Tipos de Certificados',
                            icon: 'settings',
                            route: ['configuration', 'certificates-types-preview']
                        },
                        {
                            name: 'Configuraciones generales',
                            icon: 'settings',
                            route: ['configuration', 'general-configs']
                        },
                    ]
                },
            ]
        };
    } else if (area === 'Administración') {
        menuItemsData = (): MenuItemModel[] => {
            return [
                {
                    name: 'Inicio',
                    icon: 'home',
                    route: ['home', '']
                },
                {
                    name: 'Administración',
                    icon: 'list',
                    children: [
                        {
                            name: 'Lista de certificados solicitados',
                            icon: 'list',
                            route: ['configuration', 'certificates-preview']
                        },
                    ]
                },
            ]
        };
    }else{
        /* menuItemsData = (): MenuItemModel[] => {
            return [
                {
                    name: 'Inicio',
                    icon: 'home',
                    route: ['configuration', '']
                },
            ]
        }; */
    }
}
